import { isSelected, isText } from '$textEditor/utils/currentBlock';
// import { Placeholder } from '$textEditor/Extensions';
import type { MentionOptions } from '@tiptap/extension-mention';
import {
	HubsDocumentExtension,
	HubsGalleryExtension,
	HubsImageExtension,
	HubsLinkExtension,
	HubsWidgetExtension,
	HubsCustomHtmlExtension,
	HubsQuickPollExtension,
} from '$textEditor/Components/Blocks';

import { get } from 'svelte/store';
import { createEditor } from 'svelte-tiptap';
import { _ } from 'svelte-i18n';
import SideMenu from '$textEditor/Extensions/SideMenu';
import BubbleMenu from '@tiptap/extension-bubble-menu';
import { textExtensions } from '$textEditor/textExtensions';
import { isRTL as getRTLstore } from '$lib/stores/directionStore';
import HubsMention from '$textEditor/Extensions/Mentions/mention';

const createDefaultEditor = (mentionsTipTap: MentionOptions['suggestion'], randomId: string) => {
	const isRTL = get(getRTLstore);
	const wrapperRight = () =>
		document.getElementById(`editorWrapper-${randomId}`)?.getClientRects()[0].right || 0;
	const wrapperLeft = () =>
		document.getElementById(`editorWrapper-${randomId}`)?.getClientRects()[0].left || 0;

	const leftFunction = () => wrapperLeft() - 50;
	const righFunction = () => wrapperRight() - 120;

	return createEditor({
		extensions: [
			...textExtensions(),
			HubsLinkExtension,
			HubsGalleryExtension,
			HubsDocumentExtension,
			HubsImageExtension,
			HubsWidgetExtension,
			HubsCustomHtmlExtension,
			HubsQuickPollExtension,

			// Placeholder.configure({
			// 	placeholder: get(_)('common.what.do.you.want.to.share'),
			// }),
			HubsMention.configure({
				HTMLAttributes: {
					class: 'mention',
				},
				suggestion: {
					...mentionsTipTap,
					allowSpaces: true,
				},
			}),
			SideMenu.configure({
				element: document.getElementById(`InsertBlock-${randomId}`),
				pluginKey: 'insertBlockMenu',
				leftFunc: !isRTL ? leftFunction : () => righFunction() + 20,
			}),
			SideMenu.configure({
				element: document.getElementById(`lineFormating-${randomId}`),
				pluginKey: 'formatMenu',
				shouldShow: ({ editor }) => isText(editor),
				leftFunc: !isRTL ? righFunction : leftFunction,
				tippyOptions: {
					showOnCreate: false,
				},
			}),
			BubbleMenu.configure({
				element: document.getElementById(`selectionPopover-${randomId}`),
				shouldShow: ({ editor }) => isText(editor) && isSelected(editor),
			}),
		],
	});
};

export default createDefaultEditor;
